import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pagetemplate/HomePage.vue'; 
import PortfolioPage from '@/pagetemplate/PortfolioPage.vue';
import WebDesign from '@/components/portfolio/WebDesign.vue';
import SQLDatabase from '@/components/portfolio/SQLDatabase.vue';
import VideoEditing from '@/components/portfolio/VideoEditing.vue';
import GraphicDesign from '@/components/portfolio/GraphicDesign.vue';
import PortfolioIllustration from '@/components/portfolio/PortfolioIllustration.vue';
import PortfolioInformation from '@/components/portfolio/PortfolioInformation.vue';

const routes = [
  {
    path: '/', 
    name: 'Home',
    component: HomePage 
  },
  {
    path: '/portfolio', 
    name: 'Portfolio',
    component: PortfolioPage 
  },
  {
    path: '/web-design',
    name: 'WebDesign',
    component: WebDesign
  },
  {
    path: '/sql-database',
    name: 'SQLDatabase',
    component: SQLDatabase
  },
  {
    path: '/video-editing',
    name: 'VideoEditing',
    component: VideoEditing
  },
  {
    path: '/graphic-design',
    name: 'GraphicDesign',
    component: GraphicDesign
  },
  {
    path: '/illustration',
    name: 'Illustration',
    component: PortfolioIllustration
  },
  {
    path: '/information',
    name: 'Information',
    component: PortfolioInformation
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
